export default __webpack_public_path__ + "static/media/fully-automated.1bbfab24.png";